import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Register the required components for Bar chart
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

/**
 * Bar chart wrapper.
 *
 * Fills its parent, which owns the height — a canvas with
 * `maintainAspectRatio: false` needs a sized parent. Callers put it inside a
 * .ds-chart container.
 *
 * Colours and axis styling come from helpers/chartTheme.js — pass its
 * `barOptions()` as `options` and build datasets with `barDataset()`.
 */
const BarCharts = ({ data, options }) => {
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default BarCharts;
